export async function getSpaceGameQuestions({ token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getSpaceGameQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({}),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to fetch questions");
  }
  return data;
}
